import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcelWithoutDisplayNone,
  DownloadDataFile,
  FilterJsonExactlyMatching,
  formateDate,
  formateDateWithTime,
  getDateMinusMonths,
  getEndOfMonth,
  getEndPreviousMonth,
  getStartOfMonth,
  getStartOfPreviousMonth,
  getToday,
  SortTheList,
} from "../Shared/Utility";

import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";

function Orders() {
  const globalState = useGlobalState();
  const [searchParams] = useSearchParams();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isDetailView, setIsDetailView] = useState(false);
  const [detailViewData, setDetailViewData] = useState<any>([]);
  const [FilterObjectObject, setFilterObjectObject] = useState<any>({
    StartDate: getDateMinusMonths(1),
    EndDate: getToday(),
    UserName: "",
    Email: "",
    OrderNumber: "",
    InvoiceNumber: "",
    InvoiceType: 0,
    Status: 0,
    Month: 3,
  });
  const [ShowFilters, SetShowFilters] = useState(true);
  const ShowHideFilters = () => {
    SetShowFilters(!ShowFilters);
  };
  const [ShowConfirmedOrders, SetShowConfirmedOrders] = useState(false);
  const ShowHideConfirmedOrders = () => {
    SetShowConfirmedOrders(!ShowConfirmedOrders);
  };
  const [ShowCancelledOrders, SetShowCancelledOrders] = useState(false);
  const ShowHideCancelledOrders = () => {
    SetShowCancelledOrders(!ShowCancelledOrders);
  };

  const [customerDetails, setCustomerDetails] = useState(true);
  const [billingInfo, setBillingInfo] = useState(true);
  const [shippingInfo, setShippingInfo] = useState(true);
  const [orderDetails, setOrderDetails] = useState(true);
  const [productDetails, setProductDetails] = useState(true);

  const [selectedPID, setSelectedPID] = useState(0);
  const [showModal, setshowModal] = useState(false);
  const [confirmationModalObject, setConfirmationModalObject] = useState({
    PID: "",
    Text: "",
    ToolTip: "",
    ConfirmText: "",
    Status: 0,
    Notes: "",
    Refund: 0,
    RemainingAmount: 0,
  });

  useEffect(() => {
    let fromDateStr = "";
    let toDateStr = "";
    if (FilterObjectObject.Month == 1) {
      fromDateStr = getStartOfMonth();
      toDateStr = getEndOfMonth();
    } else if (FilterObjectObject.Month == 2) {
      fromDateStr = getStartOfPreviousMonth();
      toDateStr = getEndPreviousMonth();
    } else if (FilterObjectObject.Month == 3) {
      fromDateStr = getDateMinusMonths(1);
      toDateStr = getToday();
    } else if (FilterObjectObject.Month == 4) {
      fromDateStr = getDateMinusMonths(3);
      toDateStr = getToday();
    }

    setFilterObjectObject((prevState: any) => ({
      ...prevState,
      StartDate: fromDateStr,
      EndDate: toDateStr,
    }));
  }, [FilterObjectObject.Month]);

  useEffect(() => {
    loadAdminDataForOrders();
  }, []);

  function ClearFilter() {
    FilterObjectObject.StartDate = getDateMinusMonths(1);
    FilterObjectObject.EndDate = getToday();
    FilterObjectObject.UserName = "";
    FilterObjectObject.Email = "";
    FilterObjectObject.OrderNumber = "";
    FilterObjectObject.InvoiceNumber = "";
    FilterObjectObject.Status = 0;
    FilterObjectObject.Month = 1;

    setFilterObjectObject((prevState: any) => ({
      ...prevState,
      StartDate: getDateMinusMonths(1),
      EndDate: getToday(),
      UserName: "",
      Email: "",
      OrderNumber: "",
      InvoiceNumber: "",
      Status: 0,
      Month: 1,
    }));
    loadAdminDataForOrders();
  }

  function loadAdminDataForOrders(pid: any = 0) {
    setIsAnimation(true);
    let data = {} as any;
    data.startdate = FilterObjectObject.StartDate;
    data.enddate = FilterObjectObject.EndDate;
    data.pid = pid;
    data.status = FilterObjectObject.Status;
    data.name = FilterObjectObject.UserName;
    data.email = FilterObjectObject.Email;
    data.invoicenumber = FilterObjectObject.InvoiceNumber;
    data.ordernumber = FilterObjectObject.OrderNumber;
    setSelectedPID(pid);
    setDetailViewData([]);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/LoadAdminDataForOrders", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse[0]));
          if (pid == 0) {
            setThisGridListDataWithoutFilters(deepCopy1);
            setThisGridListData(deepCopy2);
            thisGridListDataRef.current = deepCopy2;
            setIsDetailView(false);
          } else {
            setDetailViewData(deepCopy1);
            setIsDetailView(true);
          }
          console.log("l_oResponse", l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function updateOrderAdminData(
    type: any,
    pid: string,
    colname: any,
    colvalue: any,
    colvalue2: any,
    colvalue3: any,
    colvalue4: any,
  ) {
    let object = {} as any;
    object.type = type;
    object.pid = pid;
    object.colname = colname;
    object.colvalue = colvalue;
    object.colvalue2 = colvalue2;
    object.colvalue3 = colvalue3;
    object.colvalue4 = colvalue4;
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/UpdateOrderAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          loadAdminDataForOrders(selectedPID);
          setshowModal(false);
        } else {
          console.log("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(
      JSON.stringify(thisGridListDataWithoutFilters[0]),
    );
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      const firstRow = thisGridListData[0];
      Object.keys(firstRow).forEach((col) => {
        const element = document.getElementById("imgSort" + col);

        if (element) {
          element.innerHTML =
            '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
        }
      });
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  function updateSelectedPIDForParent(type: any, value: any, name: any) {
    if (type == 1) {
      FilterObjectObject.CampaignCode = value;
      setFilterObjectObject((prevState: any) => ({
        ...prevState,
        CampaignCode: value,
      }));
    }
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      <>
        {isDetailView == false && (
          <>
            <div
              className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer"
              onClick={ShowHideFilters}
            >
              Filters
              <img
                className={` ${ShowFilters ? "rotate-180" : ""}`}
                src="images/chev-down.svg"
                width={16}
                height={16}
              />
            </div>
            {ShowFilters && (
              <div className="inline-block-d text-center width-100 reuse-border p-all20">
                <div className="grid-d fr-1111 flex-gap10">
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">Month</span>
                    <select
                      value={FilterObjectObject.Month}
                      onChange={(e) => {
                        FilterObjectObject.Month = e.target.value;
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          Month: e.target.value,
                        }));
                      }}
                      className="input-field w-100"
                    >
                      <option value="1">This Month</option>
                      <option value="2">Last Month</option>
                      <option value="3">Last 30 Days</option>
                      <option value="4">Last 90 Days</option>
                    </select>
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Start Date
                    </span>
                    <input
                      type="Date"
                      className="input-field w-100"
                      value={moment(FilterObjectObject.StartDate).format(
                        "YYYY-MM-DD",
                      )}
                      onChange={(e) => {
                        FilterObjectObject.StartDate = moment(
                          e.target.value,
                        ).format("YYYY-MM-DD");
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          StartDate: moment(e.target.value).format(
                            "YYYY-MM-DD",
                          ),
                        }));
                      }}
                    />
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      End Date
                    </span>
                    <input
                      type="Date"
                      className="input-field w-100"
                      value={moment(FilterObjectObject.EndDate).format(
                        "YYYY-MM-DD",
                      )}
                      onChange={(e) => {
                        FilterObjectObject.EndDate = moment(
                          e.target.value,
                        ).format("YYYY-MM-DD");
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          EndDate: moment(e.target.value).format("YYYY-MM-DD"),
                        }));
                      }}
                    />
                  </div>

                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Customer Name
                    </span>
                    <input
                      type="text"
                      className="input-field w-100"
                      value={FilterObjectObject.UserName}
                      onChange={(e) => {
                        FilterObjectObject.UserName = e.target.value;
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          UserName: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Customer Email
                    </span>
                    <input
                      type="text"
                      className="input-field w-100"
                      value={FilterObjectObject.Email}
                      onChange={(e) => {
                        FilterObjectObject.Email = e.target.value;
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          Email: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Order Number
                    </span>
                    <input
                      type="text"
                      className="input-field w-100"
                      value={FilterObjectObject.OrderNumber}
                      onChange={(e) => {
                        FilterObjectObject.OrderNumber = e.target.value;
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          OrderNumber: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Invoice Number
                    </span>
                    <input
                      type="text"
                      className="input-field w-100"
                      value={FilterObjectObject.InvoiceNumber}
                      onChange={(e) => {
                        FilterObjectObject.InvoiceNumber = e.target.value;
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          InvoiceNumber: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Status
                    </span>
                    <select
                      value={FilterObjectObject.Status}
                      onChange={(e) => {
                        FilterObjectObject.Status = e.target.value;
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          Status: e.target.value,
                        }));
                      }}
                      className="input-field w-100"
                    >
                      <option value="0">All</option>
                      {thisGridListDataWithoutFilters[3] &&
                        thisGridListDataWithoutFilters[3].map((item: any) => (
                          <option key={item.PID} value={item.PID}>
                            {item.Name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="flex-daj btn-start flex-gap10 mt-10">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => loadAdminDataForOrders()}
                  >
                    Apply Filter
                  </a>
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => ClearFilter()}
                  >
                    Clear Filter
                  </a>
                </div>
              </div>
            )}
            <>
              <div
                className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer mt-10 mt-only"
                onClick={ShowHideConfirmedOrders}
              >
                Confirmed Orders
                <img
                  className={` ${ShowConfirmedOrders ? "rotate-180" : ""}`}
                  src="images/chev-down.svg"
                  width={16}
                  height={16}
                />
              </div>
              {ShowConfirmedOrders && (
                <div className="inline-block-d text-center width-100 reuse-border p-all20">
                  {thisGridListDataWithoutFilters[1] &&
                    thisGridListDataWithoutFilters[1][0] && (
                      <div className="grid-d fr-1111 fr-9f flex-gap10">
                        <div className="data-boxes">
                          <span className="data-txt">Orders</span>
                          <span>
                            {thisGridListDataWithoutFilters[1][0].TotalOrders}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Quantity</span>
                          <span>
                            {thisGridListDataWithoutFilters[1][0].TotalQuantity}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Free Quantity</span>
                          <span>
                            {
                              thisGridListDataWithoutFilters[1][0]
                                .TotalFreeQuantity
                            }
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Waiver</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[1][0].TotalWaiver.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>

                        <div className="data-boxes">
                          <span className="data-txt">Price</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[1][0].TotalPrice.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Discount</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[1][0].TotalDiscountAmount.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Shipping</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[1][0].TotalShippingAmount.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">VAT</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[1][0].TotalVATAmount.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Payment</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[1][0].TotalPayment.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                      </div>
                    )}
                </div>
              )}
            </>

            <>
              <div
                className="accordion-top flex-da justify-btw grey-accord pointer mtb-0 mt-10 mt-only"
                onClick={ShowHideCancelledOrders}
              >
                Cancelled Orders
                <img
                  className={` ${ShowCancelledOrders ? "rotate-180" : ""}`}
                  src="images/chev-down.svg"
                  width={16}
                  height={16}
                />
              </div>
              {ShowCancelledOrders && (
                <div className="inline-block-d text-center width-100 reuse-border p-all20">
                  {thisGridListDataWithoutFilters[2] &&
                    thisGridListDataWithoutFilters[2][0] && (
                      <div className="grid-d fr-1111 fr-9f flex-gap10">
                        <div className="data-boxes">
                          <span className="data-txt">Orders</span>
                          <span>
                            {thisGridListDataWithoutFilters[2][0].TotalOrders}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Quantity</span>
                          <span>
                            {thisGridListDataWithoutFilters[2][0].TotalQuantity}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Free Quantity</span>
                          <span>
                            {
                              thisGridListDataWithoutFilters[2][0]
                                .TotalFreeQuantity
                            }
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Waiver</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[2][0].TotalWaiver.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>

                        <div className="data-boxes">
                          <span className="data-txt">Price</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[2][0].TotalPrice.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Discount</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[2][0].TotalDiscountAmount.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Shipping</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[2][0].TotalShippingAmount.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">VAT</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[2][0].TotalVATAmount.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                        <div className="data-boxes">
                          <span className="data-txt">Payment</span>
                          <span>
                            £
                            {thisGridListDataWithoutFilters[2][0].TotalPayment.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </div>
                      </div>
                    )}
                </div>
              )}
            </>

            <>
              <div className="flex-da justify-end mt-10 mb-10 flex-gap10">
                <div className="flex-daj flex-gap10">
                  <a
                    className="link-btn btn-link-m"
                    onClick={() => ClearAllFilters()}
                  >
                    Clear All Filters
                  </a>
                  <a
                    className="btn-primary flex-daj btn-grid"
                    title="Export"
                    onClick={() =>
                      DownloadClientsDataInExcelWithoutDisplayNone(
                        "tblcampaigndata",
                        "Orders " + moment().format("DD-MM-YY HH-mm-ss"),
                      )
                    }
                  >
                    <img src="images/export.svg" width="18" height="18" />
                  </a>
                  {/* <LockUnlock locked={isLocked} setLocked={setIsLocked}></LockUnlock> */}
                </div>{" "}
              </div>
              <div className="flow-auto-lg5">
                <table className="reuse-table" id="tblcampaigndata">
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Status
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "OrderStatus")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("OrderStatus")
                              }
                              title={"Sort By OrderStatus"}
                            >
                              <span id={"imgSort" + "OrderStatus"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Dated
                            <a
                              onClick={(e) => ShowColumnFilterList(e, "Dated")}
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("Dated")}
                              title={"Sort By Dated"}
                            >
                              <span id={"imgSort" + "Dated"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Order No
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "OrderNo")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("OrderNo")}
                              title={"Sort By OrderNo"}
                            >
                              <span id={"imgSort" + "OrderNo"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Invoice No
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "InvoiceNumber")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("InvoiceNumber")
                              }
                              title={"Sort By InvoiceNumber"}
                            >
                              <span id={"imgSort" + "InvoiceNumber"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Customer Name
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "Customer")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("Customer")}
                              title={"Sort By Customer"}
                            >
                              <span id={"imgSort" + "Customer"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Customer Email
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "EmailAddress")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("EmailAddress")
                              }
                              title={"Sort By EmailAddress"}
                            >
                              <span id={"imgSort" + "EmailAddress"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Quantity
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "TotalQuantity")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("TotalQuantity")
                              }
                              title={"Sort By TotalQuantity"}
                            >
                              <span id={"imgSort" + "TotalQuantity"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            VAT
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "TaxAmount")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("TaxAmount")}
                              title={"Sort By TaxAmount"}
                            >
                              <span id={"imgSort" + "TaxAmount"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Payment
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "PayableAmount")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("PayableAmount")
                              }
                              title={"Sort By PayableAmount"}
                            >
                              <span id={"imgSort" + "PayableAmount"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {thisGridListData &&
                      thisGridListData.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          {!item.IsExcluded && (
                            <tr>
                              <td className="text-center">
                                <div className="flex-da justify-end gap-10">
                                  {item.MarkOrderConfirmed == 1 && (
                                    <a
                                      title={item.MarkOrderConfirmedToolTip}
                                      onClick={() => {
                                        setConfirmationModalObject({
                                          PID: item.PID,
                                          Text: item.MarkOrderConfirmedText,
                                          ToolTip:
                                            item.MarkOrderConfirmedToolTip,
                                          ConfirmText:
                                            item.MarkOrderConfirmedConfirmText,
                                          Status: item.MarkOrderConfirmedStatus,
                                          Notes: item.Notes,
                                          Refund: 0,
                                          RemainingAmount: 0,
                                        });
                                        setshowModal(true);
                                      }}
                                    >
                                      <img
                                        src="images/confirm-order.svg"
                                        width="18px"
                                        height="14px"
                                        alt="Edit"
                                      />
                                    </a>
                                  )}

                                  {item.MarkOrderDispatched == 1 && (
                                    <a
                                      title={item.MarkOrderDispatchedToolTip}
                                      onClick={() => {
                                        setConfirmationModalObject({
                                          PID: item.PID,
                                          Text: item.MarkOrderDispatchedText,
                                          ToolTip:
                                            item.MarkOrderDispatchedToolTip,
                                          ConfirmText:
                                            item.MarkOrderDispatchedConfirmText,
                                          Status:
                                            item.MarkOrderDispatchedStatus,
                                          Notes: item.Notes,
                                          Refund: 0,
                                          RemainingAmount: 0,
                                        });
                                        setshowModal(true);
                                      }}
                                    >
                                      <img
                                        src="images/material-req.svg"
                                        width="14px"
                                        height="14px"
                                        alt="Edit"
                                      />
                                    </a>
                                  )}

                                  {item.MarkOrderCompleted == 1 && (
                                    <a
                                      title={item.MarkOrderCompletedToolTip}
                                      onClick={() => {
                                        setConfirmationModalObject({
                                          PID: item.PID,
                                          Text: item.MarkOrderCompletedText,
                                          ToolTip:
                                            item.MarkOrderCompletedToolTip,
                                          ConfirmText:
                                            item.MarkOrderCompletedConfirmText,
                                          Status: item.MarkOrderCompletedStatus,
                                          Notes: item.Notes,
                                          Refund: 0,
                                          RemainingAmount: 0,
                                        });
                                        setshowModal(true);
                                      }}
                                    >
                                      <img
                                        src="images/tick-g.svg"
                                        width="14px"
                                        height="14px"
                                        alt="Edit"
                                      />
                                    </a>
                                  )}

                                  {item.MarkOrderCanclelled == 1 && (
                                    <a
                                      title={item.MarkOrderCanclelledToolTip}
                                      onClick={() => {
                                        setConfirmationModalObject({
                                          PID: item.PID,
                                          Text: item.MarkOrderCanclelledText,
                                          ToolTip:
                                            item.MarkOrderCanclelledToolTip,
                                          ConfirmText:
                                            item.MarkOrderCanclelledConfirmText,
                                          Status:
                                            item.MarkOrderCanclelledStatus,
                                          Notes: item.Notes,
                                          Refund: 0,
                                          RemainingAmount: 0,
                                        });
                                        setshowModal(true);
                                      }}
                                    >
                                      <img
                                        src="images/r-cross.svg"
                                        width="14px"
                                        height="14px"
                                        alt="Edit"
                                      />
                                    </a>
                                  )}

                                  {item.RefundPayment == 1 && (
                                    <a
                                      title={item.RefundPaymentToolTip}
                                      onClick={() => {
                                        setConfirmationModalObject({
                                          PID: item.PID,
                                          Text: item.RefundPaymentText,
                                          ToolTip: item.RefundPaymentToolTip,
                                          ConfirmText:
                                            item.RefundPaymentConfirmText,
                                          Status: item.RefundPaymentStatus,
                                          Notes: item.Notes,
                                          Refund: 1,
                                          RemainingAmount: item.RemainingAmount,
                                        });
                                        setshowModal(true);
                                      }}
                                    >
                                      <img
                                        src="images/pound.svg"
                                        width="14px"
                                        height="14px"
                                        alt="Edit"
                                      />
                                    </a>
                                  )}

                                  {item.ManualRefundPayment == 1 && (
                                    <a
                                      title={item.ManualRefundPaymentToolTip}
                                      onClick={() => {
                                        setConfirmationModalObject({
                                          PID: item.PID,
                                          Text: item.ManualRefundPaymentText,
                                          ToolTip:
                                            item.ManualRefundPaymentToolTip,
                                          ConfirmText:
                                            item.ManualRefundPaymentConfirmText,
                                          Status:
                                            item.ManualRefundPaymentStatus,
                                          Notes: item.Notes,
                                          Refund: 2,
                                          RemainingAmount: item.RemainingAmount,
                                        });
                                        setshowModal(true);
                                      }}
                                    >
                                      <img
                                        src="images/RefundPayment.svg"
                                        width="20px"
                                        height="20px"
                                        alt="Edit"
                                      />
                                    </a>
                                  )}

                                  {item.PDFURL != "" && (
                                    <a
                                      href={item.PDFURL}
                                      target="_blank"
                                      title="Download Invoice PDF"
                                    >
                                      <img
                                        src="images/download-t.svg"
                                        width="14px"
                                        height="14px"
                                        alt="download"
                                      />
                                    </a>
                                  )}
                                  <a
                                    title="View Details"
                                    onClick={() => {
                                      loadAdminDataForOrders(item.PID);
                                    }}
                                  >
                                    <img
                                      src="images/eye-t.svg"
                                      width="22px"
                                      height="22px"
                                      alt="Edit"
                                    />
                                  </a>
                                </div>
                              </td>
                              <td
                                onClick={() => {
                                  loadAdminDataForOrders(item.PID);
                                }}
                              >
                                {item.OrderStatus}
                              </td>
                              <td
                                onClick={() => {
                                  loadAdminDataForOrders(item.PID);
                                }}
                              >
                                {formateDateWithTime(item.Dated)}
                              </td>
                              <td
                                onClick={() => {
                                  loadAdminDataForOrders(item.PID);
                                }}
                              >
                                {item.OrderNo}
                              </td>
                              <td
                                onClick={() => {
                                  loadAdminDataForOrders(item.PID);
                                }}
                              >
                                {item.InvoiceNumber}
                              </td>
                              <td
                                onClick={() => {
                                  loadAdminDataForOrders(item.PID);
                                }}
                              >
                                {item.Customer}
                              </td>
                              <td
                                onClick={() => {
                                  loadAdminDataForOrders(item.PID);
                                }}
                              >
                                {item.EmailAddress}
                              </td>
                              <td
                                onClick={() => {
                                  loadAdminDataForOrders(item.PID);
                                }}
                                className="text-right"
                              >
                                {item.TotalQuantity}
                              </td>
                              <td
                                onClick={() => {
                                  loadAdminDataForOrders(item.PID);
                                }}
                                className="text-right"
                              >
                                £
                                {item.TaxAmount?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>

                              <td
                                onClick={() => {
                                  loadAdminDataForOrders(item.PID);
                                }}
                                className="text-right"
                              >
                                £
                                {item.PayableAmount?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          </>
        )}

        {isDetailView == true && detailViewData[0] && detailViewData[0][0] && (
          <>
            <div className="flex-gap20 mb-10 ">
              {detailViewData[0][0].Notes !== "" && (
                <>
                  <div className=" flex-d flex-as mb-20">
                    <span className="data-txt font-16 notes-width">
                      Internal Notes:
                    </span>
                    <span>{detailViewData[0][0].Notes}</span>
                  </div>
                </>
              )}

              <div className="flex-da justify-btw mb-10 flex-gap10">
                <div className="flex-daj btn-start flex-gap10">
                  {detailViewData[0][0].MarkOrderConfirmed == 1 && (
                    <a
                      className="btn-primary flex-daj"
                      title={detailViewData[0][0].MarkOrderConfirmedToolTip}
                      onClick={() => {
                        setConfirmationModalObject({
                          PID: detailViewData[0][0].PID,
                          Text: detailViewData[0][0].MarkOrderConfirmedText,
                          ToolTip:
                            detailViewData[0][0].MarkOrderConfirmedToolTip,
                          ConfirmText:
                            detailViewData[0][0].MarkOrderConfirmedConfirmText,
                          Status: detailViewData[0][0].MarkOrderConfirmedStatus,
                          Notes: detailViewData[0][0].Notes,
                          Refund: 0,
                          RemainingAmount: 0,
                        });
                        setshowModal(true);
                      }}
                    >
                      {detailViewData[0][0].MarkOrderConfirmedText}
                    </a>
                  )}

                  {detailViewData[0][0].MarkOrderDispatched == 1 && (
                    <a
                      className="btn-primary flex-daj"
                      title={detailViewData[0][0].MarkOrderDispatchedToolTip}
                      onClick={() => {
                        setConfirmationModalObject({
                          PID: detailViewData[0][0].PID,
                          Text: detailViewData[0][0].MarkOrderDispatchedText,
                          ToolTip:
                            detailViewData[0][0].MarkOrderDispatchedToolTip,
                          ConfirmText:
                            detailViewData[0][0].MarkOrderDispatchedConfirmText,
                          Status:
                            detailViewData[0][0].MarkOrderDispatchedStatus,
                          Notes: detailViewData[0][0].Notes,
                          Refund: 0,
                          RemainingAmount: 0,
                        });
                        setshowModal(true);
                      }}
                    >
                      {detailViewData[0][0].MarkOrderDispatchedText}
                    </a>
                  )}

                  {detailViewData[0][0].MarkOrderCompleted == 1 && (
                    <a
                      className="btn-primary flex-daj"
                      title={detailViewData[0][0].MarkOrderCompletedToolTip}
                      onClick={() => {
                        setConfirmationModalObject({
                          PID: detailViewData[0][0].PID,
                          Text: detailViewData[0][0].MarkOrderCompletedText,
                          ToolTip:
                            detailViewData[0][0].MarkOrderCompletedToolTip,
                          ConfirmText:
                            detailViewData[0][0].MarkOrderCompletedConfirmText,
                          Status: detailViewData[0][0].MarkOrderCompletedStatus,
                          Notes: detailViewData[0][0].Notes,
                          Refund: 0,
                          RemainingAmount: 0,
                        });
                        setshowModal(true);
                      }}
                    >
                      {detailViewData[0][0].MarkOrderCompletedText}
                    </a>
                  )}

                  {detailViewData[0][0].MarkOrderCanclelled == 1 && (
                    <a
                      className="btn-primary flex-daj"
                      title={detailViewData[0][0].MarkOrderCanclelledToolTip}
                      onClick={() => {
                        setConfirmationModalObject({
                          PID: detailViewData[0][0].PID,
                          Text: detailViewData[0][0].MarkOrderCanclelledText,
                          ToolTip:
                            detailViewData[0][0].MarkOrderCanclelledToolTip,
                          ConfirmText:
                            detailViewData[0][0].MarkOrderCanclelledConfirmText,
                          Status:
                            detailViewData[0][0].MarkOrderCanclelledStatus,
                          Notes: detailViewData[0][0].Notes,
                          Refund: 0,
                          RemainingAmount: 0,
                        });
                        setshowModal(true);
                      }}
                    >
                      {detailViewData[0][0].MarkOrderCanclelledText}
                    </a>
                  )}

                  {detailViewData[0][0].RefundPayment == 1 && (
                    <a
                      className="btn-primary flex-daj"
                      title={detailViewData[0][0].RefundPaymentToolTip}
                      onClick={() => {
                        setConfirmationModalObject({
                          PID: detailViewData[0][0].PID,
                          Text: detailViewData[0][0].RefundPaymentText,
                          ToolTip: detailViewData[0][0].RefundPaymentToolTip,
                          ConfirmText:
                            detailViewData[0][0].RefundPaymentConfirmText,
                          Status: detailViewData[0][0].RefundPaymentStatus,
                          Notes: detailViewData[0][0].Notes,
                          Refund: 1,
                          RemainingAmount: detailViewData[0][0].RemainingAmount,
                        });
                        setshowModal(true);
                      }}
                    >
                      {detailViewData[0][0].RefundPaymentText}
                    </a>
                  )}

                  {detailViewData[0][0].ManualRefundPayment == 1 && (
                    <a
                      className="btn-primary flex-daj"
                      title={detailViewData[0][0].ManualRefundPaymentToolTip}
                      onClick={() => {
                        setConfirmationModalObject({
                          PID: detailViewData[0][0].PID,
                          Text: detailViewData[0][0].ManualRefundPaymentText,
                          ToolTip:
                            detailViewData[0][0].ManualRefundPaymentToolTip,
                          ConfirmText:
                            detailViewData[0][0].ManualRefundPaymentConfirmText,
                          Status:
                            detailViewData[0][0].ManualRefundPaymentStatus,
                          Notes: detailViewData[0][0].Notes,
                          Refund: 2,
                          RemainingAmount: detailViewData[0][0].RemainingAmount,
                        });
                        setshowModal(true);
                      }}
                    >
                      {detailViewData[0][0].ManualRefundPaymentText}
                    </a>
                  )}
                </div>

                <div className="flex-daj flex-gap10">
                  <a
                    className="link-btn btn-link-m"
                    onClick={() => loadAdminDataForOrders(0)}
                  >
                    Back To Orders
                  </a>
                </div>
              </div>
            </div>
            <div className="grid-d gap-10 fr-31 flex-as font-12">
              <div className="grid-d gap-20 fr-1 flex-as font-12">
                <div className="grid-d gap-10 fr-111 flex-as font-12">
                  <div className="grid-d">
                    <div className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer mt-10 mt-only">
                      Customer Details
                    </div>
                    {customerDetails && (
                      <div className="inline-block-d text-center width-100 reuse-border p-all20">
                        {detailViewData[0] && detailViewData[0][0] && (
                          <div className="grid-d fr-1 flex-gap10">
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                First Name:
                              </span>
                              <span>{detailViewData[0][0].FirstName}</span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                Last Name:
                              </span>
                              <span>{detailViewData[0][0].LastName}</span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">Email:</span>
                              <span>{detailViewData[0][0].EmailAddress}</span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">Mobile:</span>
                              <span>{detailViewData[0][0].Mobile}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="grid-d">
                    <div
                      className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer mt-10 mt-only"
                      // onClick={() => setBillingInfo(!billingInfo)}
                    >
                      Billing Information
                      {/* <img
                    className={` ${billingInfo ? "rotate-180" : ""}`}
                    src="images/chev-down.svg"
                    width={16}
                    height={16}
                  /> */}
                    </div>
                    {billingInfo && (
                      <div className="inline-block-d text-center width-100 reuse-border p-all20">
                        {detailViewData[0] && detailViewData[0][0] && (
                          <div className="grid-d fr-1 flex-gap10">
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                Postcode:
                              </span>
                              <span>{detailViewData[0][0].PostCode}</span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                House Number:
                              </span>
                              <span>{detailViewData[0][0].HouseNumber}</span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                1 Line of address:
                              </span>
                              <span>{detailViewData[0][0].AddressLine1}</span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                2 Line of address:
                              </span>
                              <span>{detailViewData[0][0].AddressLine2}</span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                City/Town:
                              </span>
                              <span>{detailViewData[0][0].City}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="grid-d">
                    <div
                      className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer mt-10 mt-only"
                      // onClick={() => setShippingInfo(!shippingInfo)}
                    >
                      Shipping Information
                      {/* <img
                    className={` ${shippingInfo ? "rotate-180" : ""}`}
                    src="images/chev-down.svg"
                    width={16}
                    height={16}
                  /> */}
                    </div>
                    {shippingInfo && (
                      <div className="inline-block-d text-center width-100 reuse-border p-all20">
                        {detailViewData[0] && detailViewData[0][0] && (
                          <div className="grid-d fr-1 flex-gap10">
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                Postcode:
                              </span>
                              <span>
                                {detailViewData[0][0].ShippingPostCode}
                              </span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                House Number:
                              </span>
                              <span>
                                {detailViewData[0][0].ShippingHouseNumber}
                              </span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                1 Line of address:
                              </span>
                              <span>
                                {detailViewData[0][0].ShippingAddressLine1}
                              </span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                2 Line of address:
                              </span>
                              <span>
                                {detailViewData[0][0].ShippingAddressLine2}
                              </span>
                            </div>
                            <div className="flex-d gap-10 flex-ac font-mont">
                              <span className="data-txt font-12">
                                City/Town:
                              </span>
                              <span>{detailViewData[0][0].ShippingCity}</span>
                            </div>
                          </div>
                        )}
                        {/* {detailViewData[0] &&
                      detailViewData[0][0] &&
                      detailViewData[0][0].SameBothAddress == 1 && (
                        <div className="grid-d fr-1 flex-gap10">
                          <div className="flex-d gap-10 flex-ac font-mont">
                            <input type="checkbox" checked disabled />
                            <span>Same As Billing Address</span>
                          </div>
                        </div>
                      )} */}
                      </div>
                    )}
                  </div>
                </div>
                {detailViewData[0][0].Comments !== "" && (
                  <>
                    <div className=" grid-d  flex-gap10">
                      <span className="data-txt font-16">
                        Delivery Instructions
                      </span>
                      <span>{detailViewData[0][0].Comments}</span>
                    </div>
                  </>
                )}
              </div>
              <div className="grid-d">
                <div
                  className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer mt-10 mt-only"
                  // onClick={() => setOrderDetails(!orderDetails)}
                >
                  Order Details
                  {/* <img
                    className={` ${orderDetails ? "rotate-180" : ""}`}
                    src="images/chev-down.svg"
                    width={16}
                    height={16}
                  /> */}
                </div>
                {orderDetails && (
                  <div className="inline-block-d text-center width-100 reuse-border p-all20">
                    <div className="grid-d fr-1 flex-gap10">
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">Status:</span>
                        <span>{detailViewData[0][0].OrderStatus}</span>
                      </div>
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">Dated:</span>
                        <span>
                          {formateDateWithTime(detailViewData[0][0].Dated)}
                        </span>
                      </div>
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">Order No:</span>
                        <span>{detailViewData[0][0].OrderNo}</span>
                      </div>
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">Invoice No:</span>
                        <span>{detailViewData[0][0].InvoiceNumber}</span>
                      </div>
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">Quantity:</span>
                        <span>{detailViewData[0][0].TotalQuantity}</span>
                      </div>
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">VAT:</span>
                        <span>
                          {" "}
                          £
                          {detailViewData[0][0].TaxAmount?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </span>
                      </div>
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">
                          Payment Recieved:
                        </span>
                        <span>
                          {" "}
                          £
                          {detailViewData[0][0].PayableAmount?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </span>
                      </div>
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">Waiver:</span>
                        <span>
                          {" "}
                          £
                          {detailViewData[0][0].TotalDiscount?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </span>
                      </div>
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">
                          Voucher Discount:
                        </span>
                        <span>
                          {" "}
                          £
                          {detailViewData[0][0].PTDiscountAmount?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </span>
                      </div>
                      <div className="flex-d gap-10 flex-ac font-mont">
                        <span className="data-txt font-12">
                          Shipping Amount:
                        </span>
                        <span>
                          {" "}
                          £
                          {detailViewData[0][0].ShippingAmount?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div
              className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer mt-10 mt-only"
              // onClick={() => setProductDetails(!productDetails)}
            >
              Products
              {/* <img
                className={` ${productDetails ? "rotate-180" : ""}`}
                src="images/chev-down.svg"
                width={16}
                height={16}
              /> */}
            </div>

            {productDetails && (
              <div className="inline-block-d text-center width-100 reuse-border p-all20">
                <div className="flow-auto-lg5 mt-10 mb-10 flex-gap10">
                  <table className="reuse-table" id="tblcampaigndata">
                    <thead>
                      <tr>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Product Code</th>
                        <th>Product Price</th>
                        <th>Price After Discount</th>
                        <th>Quantity</th>
                        <th>Free Quantity</th>
                        <th>Total Sales/Offer Discount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailViewData[1] &&
                        detailViewData[1].map((item: any, index: any) => (
                          <React.Fragment key={index}>
                            {!item.IsExcluded && (
                              <tr>
                                <td>
                                  {" "}
                                  <img
                                    src={item.MainImageURL}
                                    width="80px"
                                    height="80px"
                                    alt="img"
                                  />
                                </td>
                                <td>{item.Name}</td>
                                <td>{item.SKU}</td>

                                <td className="text-right">
                                  £
                                  {item.PriceAmount?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>

                                <td className="text-right">
                                  £
                                  {item.Price?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td className="text-right">{item.Quantity}</td>
                                <td className="text-right">{item.FreeQty}</td>
                                <td className="text-right">
                                  £
                                  {item.TotalSalesDiscount?.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </>

      {showModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">
                  {confirmationModalObject.ConfirmText}
                </h3>
                <a
                  className="close-help"
                  onClick={() => {
                    setshowModal(false);
                  }}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <div className="modal-body">
                <div className="grid-d fr-1 gap-20 mt-20">
                  {confirmationModalObject.Refund > 0 && (
                    <h6>
                      Refund Amount: £{confirmationModalObject.RemainingAmount}
                    </h6>
                  )}
                  <div className="field-input grid-d flex-gap3">
                    <div className="font-12 text-left label-color">Notes</div>
                    <textarea
                      className="input-field w-100 h-notes"
                      value={confirmationModalObject.Notes}
                      onChange={(e) =>
                        setConfirmationModalObject((prev: any) => ({
                          ...prev,
                          Notes: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className="flex-daj btn-start mt-10 flex-gap10">
                    <a
                      className="flex-daj btn-primary"
                      onClick={() =>
                        updateOrderAdminData(
                          1,
                          confirmationModalObject.PID,
                          confirmationModalObject.Refund == 0
                            ? "Status"
                            : confirmationModalObject.Refund == 1
                              ? "Refund"
                              : "ManualRefund",
                          confirmationModalObject.Refund > 0
                            ? confirmationModalObject.RemainingAmount
                            : confirmationModalObject.Status,
                          confirmationModalObject.Notes,
                          "",
                          "",
                        )
                      }
                    >
                      Yes
                    </a>
                    <a
                      className="flex-daj btn-primary"
                      onClick={() => {
                        setshowModal(false);
                      }}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Orders;
